import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndianNumberPipe } from '../indian-number.pipe'; 
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { PurchaseStockMappingModalComponent } from './purchase-stock-mapping/purchase-stock-mapping.modal';

@NgModule({
  declarations: [
    IndianNumberPipe,
    PurchaseStockMappingModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule
  ],
  exports: [
    IndianNumberPipe,
    PurchaseStockMappingModalComponent
  ]
})
export class SharedModule { }
